import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgArrowUp" data-sentry-source-file="arrow-up.tsx">
    <g clipPath="url(#arrow-up_svg__a)" data-sentry-element="g" data-sentry-source-file="arrow-up.tsx">
      <path fill="#263E6A" d="M3.333 17.333 2 16 12 6l10 10-1.333 1.333L12 8.667z" data-sentry-element="path" data-sentry-source-file="arrow-up.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="arrow-up.tsx">
      <clipPath id="arrow-up_svg__a" data-sentry-element="clipPath" data-sentry-source-file="arrow-up.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="arrow-up.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgArrowUp;